import { render, staticRenderFns } from "./BannerCouponPreload.vue?vue&type=template&id=2e52cc0b"
import script from "./BannerCouponPreload.vue?vue&type=script&lang=js"
export * from "./BannerCouponPreload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports